import { c as _c } from "react/compiler-runtime";
import { useListTaxonomyAliases } from '@/api/generated/taxonomy/taxonomy';
import { useConfig } from '@/hooks/use-config';
import { useProjectsContext } from '@/providers/projects-provider';
import { createContext, useCallback, useContext, useMemo } from 'react';
import { collectAggregateDisplayNames, formatKindAliasName } from './alias.utils';
export { collectAggregateDisplayNames, formatKindAliasName, resolveKindAlias } from './alias.utils';
const AliasContext = createContext<{
  aliases: Record<string, Record<string, string>>;
  refetchAliases: () => void;
}>({
  aliases: {},
  refetchAliases: () => {}
});
export const AliasProvider = t0 => {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    projectId
  } = useProjectsContext();
  const t1 = !!projectId;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      query: {
        enabled: t1
      }
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: aliases,
    refetch: refetchAliases
  } = useListTaxonomyAliases(projectId, t2);
  let t3;
  if ($[2] !== aliases) {
    t3 = aliases ?? {};
    $[2] = aliases;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== refetchAliases || $[5] !== t3) {
    t4 = {
      aliases: t3,
      refetchAliases
    };
    $[4] = refetchAliases;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t4) {
    t5 = <AliasContext.Provider value={t4}>{children}</AliasContext.Provider>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export const useAliasContext = () => {
  const context = useContext(AliasContext);
  if (!context) {
    throw new Error("useAliasContext context must be use inside AliasProvider");
  }
  return context;
};
export const useAliasedName = () => {
  const $ = _c(2);
  const {
    aliases
  } = useAliasContext();
  let t0;
  if ($[0] !== aliases) {
    t0 = (type, value) => aliases[type]?.[value] ?? value;
    $[0] = aliases;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export type KindAliasFn = (kind: string) => string | undefined;
export const useAliasedKindName = () => {
  const $ = _c(7);
  const {
    aliases
  } = useAliasContext();
  const {
    projectId
  } = useProjectsContext();
  const {
    data: config
  } = useConfig(projectId);
  config?.aggregates;
  let t0;
  if ($[0] !== config?.aggregates) {
    t0 = config?.aggregates ?? [];
    $[0] = config?.aggregates;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = collectAggregateDisplayNames(t0);
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const aggregateDisplayNames = t1;
  let t2;
  if ($[4] !== aggregateDisplayNames || $[5] !== aliases) {
    t2 = kind => formatKindAliasName(aliases, kind, aggregateDisplayNames);
    $[4] = aggregateDisplayNames;
    $[5] = aliases;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};